var _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "gray",
    strokeLinecap: "square",
    strokeWidth: 1.167,
    points: "0 7 3.5 3.5 0 0",
    transform: "translate(1 1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbNext);
export default __webpack_public_path__ + "static/media/breadcrumb-next.6c95e4438aad2ac2f0f1e665dcb3a007.svg";
export { ForwardRef as ReactComponent };